var installedModules = {};
var moduleToHandlerMapping = {
	10297: {
		getter: function() { return Promise.all([__webpack_require__.e(6901), __webpack_require__.e(9044), __webpack_require__.e(6715), __webpack_require__.e(6391)]).then(function() { return function() { return __webpack_require__(86715); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	9340: {
		getter: function() { return __webpack_require__.e(987).then(function() { return function() { return __webpack_require__(13368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	72088: {
		getter: function() { return Promise.all([__webpack_require__.e(6901), __webpack_require__.e(1106)]).then(function() { return function() { return __webpack_require__(91106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	13606: {
		getter: function() { return Promise.all([__webpack_require__.e(9044), __webpack_require__.e(6391), __webpack_require__.e(771)]).then(function() { return function() { return __webpack_require__(28133); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	92650: {
		getter: function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(6391), __webpack_require__.e(4642)]).then(function() { return function() { return __webpack_require__(29965); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	12462: {
		getter: function() { return __webpack_require__.e(4953).then(function() { return function() { return __webpack_require__(14953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	70277: {
		getter: function() { return function() { return __webpack_require__(96540); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	4072: {
		getter: function() { return Promise.all([__webpack_require__.e(9710), __webpack_require__.e(9320)]).then(function() { return function() { return __webpack_require__(79320); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	35061: {
		getter: function() { return Promise.all([__webpack_require__.e(9710), __webpack_require__.e(5065)]).then(function() { return function() { return __webpack_require__(15065); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	58775: {
		getter: function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(2346)]).then(function() { return function() { return __webpack_require__(74848); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	61229: {
		getter: function() { return function() { return __webpack_require__(96540); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	42115: {
		getter: function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(4480)]).then(function() { return function() { return __webpack_require__(5338); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	76391: {
		getter: function() { return function() { return __webpack_require__(40961); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	89710: {
		getter: function() { return function() { return __webpack_require__(96540); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">= 16.8.0 || 17.x.x || ^18.0.0-0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	97108: {
		getter: function() { return function() { return __webpack_require__(96540); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	29718: {
		getter: function() { return function() { return __webpack_require__(40961); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	9473: {
		getter: function() { return __webpack_require__.e(8725).then(function() { return function() { return __webpack_require__(91106); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.5.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	32241: {
		getter: function() { return __webpack_require__.e(3368).then(function() { return function() { return __webpack_require__(13368); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.5.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	46961: {
		getter: function() { return function() { return __webpack_require__(96540); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.14.0 || ^15.0.0 || ^16.0.0-0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	65671: {
		getter: function() { return function() { return __webpack_require__(96540); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=16.4.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	73581: {
		getter: function() { return __webpack_require__.e(4953).then(function() { return function() { return __webpack_require__(14953); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.5.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	4922: {
		getter: function() { return function() { return __webpack_require__(96540); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=16.8.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	64527: {
		getter: function() { return function() { return __webpack_require__(40961); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	1823: {
		getter: function() { return __webpack_require__.e(8133).then(function() { return function() { return __webpack_require__(28133); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.5.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	35445: {
		getter: function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(2419)]).then(function() { return function() { return __webpack_require__(29965); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.5.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	86771: {
		getter: function() { return function() { return __webpack_require__(96540); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.14.0 || ^15.0.1 || ^16.0.0 || ^17.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	}
};
var initialConsumes = [10297,9340,72088,13606,92650,12462,70277,4072,35061,58775,61229,70277,42115,76391,61229,58775,35061,9473,32241,46961,65671,73581,4922,64527,1823,35445,86771,86771];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"103": [
		4922,
		64527
	],
	"297": [
		10297
	],
	"636": [
		58775,
		35061
	],
	"1823": [
		1823
	],
	"2241": [
		32241
	],
	"2346": [
		97108
	],
	"3332": [
		86771
	],
	"3581": [
		73581
	],
	"4480": [
		29718
	],
	"5445": [
		35445
	],
	"5527": [
		9340,
		72088,
		13606,
		92650,
		12462,
		70277,
		4072,
		35061,
		58775,
		61229
	],
	"5671": [
		65671
	],
	"6391": [
		76391
	],
	"6961": [
		46961
	],
	"7442": [
		86771
	],
	"8792": [
		70277,
		42115,
		76391,
		61229
	],
	"9473": [
		9473
	],
	"9710": [
		89710
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}